import type { BaseResponse } from "@marketplace/shared/types";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { SetupAutomationNotifyRequestDto } from "../../dtos/setup-automation-notify-request-dto";
import { AutomationQueryKeys } from "../../generators/automation-query-keys";
import { AutomationService } from "../../services/automation-service";

type UseGetAutomationNotifySetupQueryParams = {
  id: string | undefined;
  options?: Omit<
    UseQueryOptions<BaseResponse<SetupAutomationNotifyRequestDto> | null>,
    "queryKey" | "queryFn"
  >;
};

export const useGetAutomationNotifySetupQuery = ({
  id,
  options
}: UseGetAutomationNotifySetupQueryParams) => {
  return useQuery({
    queryKey: id
      ? AutomationQueryKeys.getAutomationNotifySetup(id).queryKey
      : ["automation", "getAutomationNotifySetup", "undefined"],
    queryFn: async () => {
      if (!id) return null;
      try {
        const res = await AutomationService.getAutomationNotifySetup({
          payload: { id }
        });
        return res;
      } catch (error: unknown) {
        const status =
          error &&
          typeof error === "object" &&
          "response" in error &&
          error.response &&
          typeof error.response === "object" &&
          "status" in error.response
            ? (error.response as { status: number }).status
            : undefined;
        if (status === 404 || status === 400) return null;
        throw error;
      }
    },
    ...options
  });
};
